"use client";

import { memo } from "react";
import { HeroDark } from "@/components/screen/global-components/hero";

const TermsHero = ({
}: React.ComponentProps<"section">) => {
  return <HeroDark title="Languex terms of service" description="This page outlines the rules for using Languex.co, our product and services and helps you understand your rights and responsibilities when accessing our services." descriptionClassName="lg:max-w-[585] lg:mx-auto" />;
};

export default memo(TermsHero);
